import { backerCard, moneyList } from "@/mocks/expose";

const iconMap = ["ri-stack-line", "ri-map-pin-line", "ri-money-cny-circle-line", "ri-timer-line"];

export default function BackerModule() {
  return (
    <section id="backers" className="bg-background-100/60">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
              <i className="ri-bank-line text-base"></i>
              Capital · 背后金主
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              钱从哪来，人归谁管
            </h2>
          </div>
          <a
            href="#archive"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-600"
          >
            查看穿透档案 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-6 grid gap-6 lg:grid-cols-2">
          {/* 克制配图 + 核心个案 */}
          <article className="overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
            <div className="relative h-52 md:h-60">
              <img
                src={backerCard.img}
                alt="背后金主与资本穿透：都市金融区黄昏实景"
                title="背后金主 资本穿透 未公开信息"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <span className="absolute left-4 top-4 rounded bg-accent-500 px-2 py-1 text-[11px] font-semibold text-background-50">
                资本穿透 · 个案 07
              </span>
            </div>
            <div className="p-5 md:p-6">
              <h3 className="font-heading text-xl font-bold leading-8 text-foreground-950">
                {backerCard.title}
              </h3>
              <p className="mt-3 text-sm leading-6 text-foreground-600">{backerCard.desc}</p>
              <dl className="mt-4 grid gap-2 sm:grid-cols-2">
                {backerCard.checks.map((c, i) => (
                  <div key={c.k} className="flex items-start gap-2 rounded-md bg-background-100 p-3">
                    <i className={`mt-0.5 text-base text-accent-600 ${iconMap[i]}`}></i>
                    <div className="min-w-0">
                      <dt className="text-[11px] text-foreground-500">{c.k}</dt>
                      <dd className="text-sm text-foreground-800">{c.v}</dd>
                    </div>
                  </div>
                ))}
              </dl>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                <span className="text-[11px] text-foreground-500">信息源：</span>
                {backerCard.sources.map((s) => (
                  <span
                    key={s}
                    className="rounded-full border border-background-200 bg-background-50 px-2.5 py-0.5 text-[11px] text-foreground-600"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </article>

          {/* 关联线索速览 */}
          <div className="flex flex-col gap-3">
            <p className="text-sm font-medium text-foreground-700">
              <i className="ri-link-m mr-1 text-primary-600"></i>
              同一方向的相关线索，建议连起来看：
            </p>
            {moneyList.map((m, i) => (
              <article
                key={m.title}
                className="rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <div className="flex items-start gap-3">
                  <span className="font-heading text-lg font-black text-secondary-300">
                    0{i + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h4 className="text-[15px] font-semibold leading-6 text-foreground-900">
                      {m.title}
                    </h4>
                    <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-chat-3-line"></i> {m.hot} 讨论
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-file-list-3-line"></i> 证据 2~4 条
                      </span>
                    </div>
                  </div>
                  <i className="ri-arrow-right-line text-lg text-foreground-300"></i>
                </div>
              </article>
            ))}
            <div className="mt-auto rounded-lg border border-dashed border-background-300 bg-background-50/50 p-4">
              <p className="text-sm text-foreground-700">
                <i className="ri-lightbulb-flash-line mr-1 text-accent-600"></i>
                编辑提示：穿透只做公开交叉验证，涉及个人隐私的部分，我们会严格打码后再公开。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}